import type { FaireProductEntity } from "../../entity_types/product";

export const p_d6xdpe6my8: FaireProductEntity = {
  token: "p_d6xdpe6my8",
  type: "product",
  name: "Crystal Fluorite Buddha Head Cabochon for Zen Yoga Jewelry",
  brandToken: "b_de8f5way8k",
  brandName: "Rock Paradise",
  imageUrl:
    "https://cdn.faire.com/fastly/75efc472418a633076e8f5bb884221b73d7a61f4342014e724d1a2dbbd262b78.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/943e07b66812a175443caba43aa04a6abb96c5ed14778cb97a0ddd75683abdb5.jpeg",
    "https://cdn.faire.com/fastly/8536f0ec108b00cf621283ce47fbc0403d5d6be41861ccef180afe06e4620272.jpeg",
    "https://cdn.faire.com/fastly/a46fcfa611fff4612b01bf58b47d90c56b26715dc6f21f83081ed8c97154b2da.jpeg",
    "https://cdn.faire.com/fastly/e51f05fb88141ee8426156e646be6bc181598098e94bc3ef69a5d83ce5490a51.jpeg",
  ],
  priceDollars: 19.5,
  description:
    "Listing is for ONE (1) Buddha Buddah Head fluorite crystal cabochon (RK36B27-07)\n\nSTOCK PHOTO. Each bead may vary slightly in size and characteristics.\n\nGreat quality! So beautiful!\n\nApproximate sizing is 30mm x 22mm",
  tags: [],
  msrpDollars: 39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:42.158Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
